import Box from '@amzn/meridian/box';
import Table, { TableCell, TableRow } from '@amzn/meridian/table';
import React from 'react';
import Text from '@amzn/meridian/text';

export interface AllocationLegendEntry {
  abbreviation: string;
  fullName: string;
  color: string;
  percentage: number;
  fixtureCount: number;
}

export interface AllocationLegendProps {
  entries: AllocationLegendEntry[];
}

const AllocationLegend: React.FC<AllocationLegendProps> = ({ entries }) => {
  const showPercentages = entries.length === 0 || entries.some((e) => e.percentage > 0);

  return (
    <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
      <Box width="400px">
        <Table showDividers spacing="small" headerRows={1} layout="fixed">
          <TableRow>
            <TableCell>{showPercentages ? 'Abbr' : 'Name'}</TableCell>
            <TableCell>{showPercentages ? 'Subcategory' : 'Department'}</TableCell>
            {showPercentages && <TableCell>%</TableCell>}
            <TableCell>Fixtures</TableCell>
          </TableRow>
          {entries.map((entry) => (
            <TableRow key={entry.abbreviation + entry.fullName}>
              <TableCell>
                <Text breakWord>{entry.abbreviation}</Text>
              </TableCell>
              <TableCell backgroundColor={entry.color}>
                <Text breakWord color="inverted">
                  {entry.fullName}
                </Text>
              </TableCell>
              {showPercentages && (
                <TableCell>
                  <Text>{entry.percentage}%</Text>
                </TableCell>
              )}
              <TableCell>
                <Text>{entry.fixtureCount}</Text>
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </Box>
    </div>
  );
};

export default AllocationLegend;
